import {Component, OnInit, Injector} from "@angular/core";
import {AppComponentBase} from "../../../services/AppComponentBase";
import {
    ScannerPrimarySearchListItems,
    ScannerPrimarySearchList,
    ScannerSideListItems,
    ScannerSide,
    ScannerChartingStudy,
    ScannerChartingStudyItems
} from "../interfaces/scanner.enums";

import {historyPeriods, HistoryItemPeriod} from "../../../interfaces/historyItem";
import {quoteFilterTabsParams, quoteFilterTabsList} from "../../quoteFilterTabs/quoteFilterTabs.list";
import {filter} from 'rxjs/operators';

@Component({
    selector: "app-scanner-searchTerms",
    template: require('./scanner-searchTerms.component.html'),
    styles: [require('./scanner-searchTerms.component.scss')]
})
export class ScannerSearchTermsComponent extends AppComponentBase implements OnInit {
    primarySearchInstruments: object = ScannerPrimarySearchListItems();
    get marketList()
    {
        let markets = quoteFilterTabsParams();
        if(this.workspace.availableAssetsForUser != undefined) {
            return markets.filter(m => this.workspace.availableAssetsForUser!.indexOf(m.label.toLowerCase()) !== -1);
        }
        return markets;
    }
    sideList: object = ScannerSideListItems();
    chartingStudyList: object = ScannerChartingStudyItems();

    public get periods(): {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[] {
        return this.workspace.periodsList;
    }

    public set periods(value: {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[]) {
        this.workspace.periodsList = value;
    }

    constructor(injector: Injector) {
        super(injector);
    }


    public openSavedScans()
    {
        this.folderState = !this.folderState;
        this.globaGridMode.setFolderState.next(this.folderState)
    }

    private _folderState: boolean = false;
    public get folderState(): boolean {
        return this._folderState;
    }
    public set folderState(value: boolean) {
        this._folderState = value;
    }
   




    public get scannerSearch_market(): quoteFilterTabsList {
        return this.workspace.scannerSearch_market;
    }
    public set scannerSearch_market(value: quoteFilterTabsList) {
        this.workspace.scannerSearch_market = value;
    }

    private _scannerHead: string = "Primary search";
    public get scannerHead(): string {
        return this._scannerHead;
    }
    public set scannerHead(value: string) {
        this._scannerHead = value;
    }
    //private _scannerSearch_primary: ScannerPrimarySearchList = ScannerPrimarySearchList.SCANNER_WIZARD;
    public get scannerSearch_primary(): ScannerPrimarySearchList {
        return this.workspace.selectedPrimaryScanner;
    }
    public set scannerSearch_primary(value: ScannerPrimarySearchList) {
        if(value == ScannerPrimarySearchList.SCANNER_WIZARD) {
            this.scannerSearch_period = "NO";
            this.scannerSearch_side = "NO";
        }
        this.workspace.allowScanProcess = false;
        this.workspace.selectedPrimaryScanner = value;
    }

    public get scannerSearch_period(): HistoryItemPeriod | string {
        return this.workspace.scannerSearch_period;
    }
    public set scannerSearch_period(value: HistoryItemPeriod | string) {
        console.log("SETSP")
        this.workspace.scannerSearch_period = value;
        this.workspace.globaGridMode.changeScannerSide.next(value);
    }

    public get scannerSearch_side(): ScannerSide | string {
        return this.workspace.scannerSearch_side;
    }
    public set scannerSearch_side(value: ScannerSide | string) {
        this.workspace.globaGridMode.changeScannerSide.next(value);

        if(this.workspace.usePrimarySide) {
            this.workspace.globaGridMode.changeScannerNarrowSide.next(value);
        }

        this.workspace.scannerSearch_side = value;
    }

    public get scannerSearch_chartingstudy(): ScannerChartingStudy | string {
        return this.workspace.scannerSearch_chartingstudy;
    }
    public set scannerSearch_chartingstudy(value: ScannerChartingStudy | string) {
        this.workspace.scannerSearch_chartingstudy = value;
    }

    public ScannerPrimarySearchList = ScannerPrimarySearchList;
    public ScannerChartingStudy = ScannerChartingStudy;


    public setActiveInstrument(id: any) {
        this.scannerSearch_primary = id;
    }

    public get selectedScannerImage() {
        let img = (this.primarySearchInstruments as {id: string, label: string, image?: string}[]).find(v => {
            return v.id == this.scannerSearch_primary
        })

        if(img) {
            return img.image
        }
        else {
            return "";
        }
    }

    get canShowMarket() {
        return true;
    }

    get canShowTimeframe() {
        return true;
    }

    get canShowSide() {
        return true;
    }


    ngOnInit() {}
}
